// extracted by mini-css-extract-plugin
export default {"AppContent":"App_AppContent__57T01"};